export default __webpack_public_path__ + "static/home-page-collage-a99d69dbc55441a8135f262e5d989dc2.webp";